module.exports = {"discord":{"client_id":"701591092730134528","client_secret":"Y04eN2BlhvQxXBCvH_zFnjvsWYbcvlNl","grant_type":"authorization_code","redirect_uri":"https://fred-vue.skydev.one","scope":"identify"},"avatar_cdn":"https://cdn.discordapp.com/avatars","vue_config":{"navbar_feature":false,"fred_session_collection":"fred_session","fred_session_current_doc":"current"}}


//////////////////
// WEBPACK FOOTER
// ./auth_config.json
// module id = kMb3
// module chunks = 1